import { errorHandlerFx } from '../../../../../../model/errorHandler';
import { createEffectJWT } from '../../../../../../model/JWT';
import { contractCreate } from '../../../../../../apiRPC/contracts';

export const contractCreateFX = errorHandlerFx(createEffectJWT(contractCreate));
